export type LoanQuoteResponse = {
  id: number;
  createdDate: string;
  createdByUserId: number;
  holdback: number;
  loanAmount: number;
  expectedCompletionDate: string;
  interest: number;
  term: number;
  total: number;
};
